import Permissions from '../constants/Permissions';
import RedirectLogin from '../views/Auth/RedirectLogin';
import TransactionRequest from '../views/Request/TransactionRequest';
import AccountSetting from '../views/User/AccountSetting';
import ChangePasswordPage from '../views/User/ChangePasswordPage';
import { BaseRouteInfo, RouteInfoGroup, RouteInfoItem } from './types';

export type RouteInfo = (BaseRouteInfo & RouteInfoItem) | (BaseRouteInfo & RouteInfoGroup);

// [add-new-page] for route and menu item
export const ROUTE_INFOS: RouteInfo[] = [
  {
    key: 'accountSetting',
    route: 'accountSetting',
    element: <AccountSetting />,
    permission: '',
    isHideMenu: true,
  },
  {
    key: 'changePassword',
    route: 'changePassword',
    element: <ChangePasswordPage />,
    permission: '',
    isHideMenu: true,
  },
  {
    key: 'transactionRequest',
    route: 'transactionRequest',
    element: <TransactionRequest />,
    permission: Permissions.TransactionRequest.Prefix,
  },
];
